import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'src/styles/media';

const Stop = ({ time, name, large }) => (
  <Root large={large}>
    <h3>{time}</h3>
    <p>{name}</p>
  </Root>
);

export default Stop;

Stop.propTypes = {
  time: PropTypes.string,
  name: PropTypes.string,
  large: PropTypes.bool,
};

const Root = styled.div`
  background-color: #eaeaec;
  z-index: 1;
  height: 10%;
  width: 30%;
  vertical-align: text-top;
  margin: 30px 0;
  @media (min-width: ${media.md}) {
    transform: translateY(30%);
    width: 10%;
    overflow: visible;
  }
  p {
    width: 200%;
    font-family: ${({ theme }) => theme.fontMain};
    font-size: 18px;
    line-height: 24px;
    margin-left: -50%;
    margin-top: 6.5px;
    @media (min-width: ${media.mdup}) {
      font-size: 18px;
      line-height: 24px;
      margin-top: 12.5px;
      width: ${props => (props.large ? '150%' : '100%')};
      margin-left: ${props => (props.large ? '-25%' : 0)};
    }
  }
  h3 {
    color: ${({ theme }) => theme.colorTransitBlue};
    font-family: ${({ theme }) => theme.fontHeader};
    text-transform: uppercase;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Transit/elements/Stop.js